// extracted by mini-css-extract-plugin
export default {"overlay":"NewsletterDialog_overlay__mIGEV"};